import PropTypes from "prop-types"
import React, { useState } from "react"
import { Button, Collapse, Row } from "reactstrap"
import CardPricing from "./card-pricing"

// Aufklappbares "Pulldown" für Add-on-Pakete, damit die Hauptlinie
// (Free / Basic / Partner Cockpit) übersichtlich bleibt.
const AddonPackagesDropdown = ({
  addons,
  title = "Add-on Packages",
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen)

  if (!addons || addons.length === 0) return null

  return (
    <div className="mt-4">
      <Button
        color="light"
        className="d-flex align-items-center gap-2 mb-3"
        onClick={() => setOpen(!open)}
      >
        <i className={`bx ${open ? "bx-chevron-up" : "bx-chevron-down"}`} />
        {title} ({addons.length})
      </Button>
      <Collapse isOpen={open}>
        <Row className="justify-content-start">
          {addons.map((addon, key) => (
            <CardPricing pricing={addon} key={"_addon_" + key} />
          ))}
        </Row>
      </Collapse>
    </div>
  )
}

AddonPackagesDropdown.propTypes = {
  addons: PropTypes.array,
  title: PropTypes.string,
  defaultOpen: PropTypes.bool,
}

export default AddonPackagesDropdown
